import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import Guides from './pages/Guides';
import News from './pages/News';
import NewsArticle from './pages/NewsArticle';
import ContactPage from './pages/Contact';
import GettingStarted from './pages/guides/GettingStarted';
import CasinoBonuses from './pages/guides/CasinoBonuses';
import ChoosingSafeCasino from './pages/guides/ChoosingSafeCasino';
import PaymentMethods from './pages/guides/PaymentMethods';
import SlotGamesStrategy from './pages/guides/SlotGamesStrategy';
import TableGamesGuide from './pages/guides/TableGamesGuide';
import LiveCasinoGames from './pages/guides/LiveCasinoGames';
import ResponsibleGambling from './pages/guides/ResponsibleGambling';
import WithdrawingWinnings from './pages/guides/WithdrawingWinnings';
import NewUKGamblingRegulations2026 from './pages/news/NewUKGamblingRegulations2026';
import Top5CasinoBonusesDecember2025 from './pages/news/Top5CasinoBonusesDecember2025';
import HowToSpotTrustworthyOnlineCasino from './pages/news/HowToSpotTrustworthyOnlineCasino';
import UKCasinoIndustryRecordGrowth2025 from './pages/news/UKCasinoIndustryRecordGrowth2025';
import PaymentMethodsRevolutionizingUKCasinoWithdrawals from './pages/news/PaymentMethodsRevolutionizingUKCasinoWithdrawals';
import LiveCasinoGamesFutureOnlineGaming from './pages/news/LiveCasinoGamesFutureOnlineGaming';
import CryptocurrencyAdoptionUKOnlineCasinos from './pages/news/CryptocurrencyAdoptionUKOnlineCasinos';
import SlotGameInnovations2025 from './pages/news/SlotGameInnovations2025';
import ResponsibleGamblingNewToolsUKPlayers from './pages/news/ResponsibleGamblingNewToolsUKPlayers';
import Reviews from './pages/Reviews';
import PubCasino from './pages/reviews/PubCasino';
import NRG from './pages/reviews/NRG';
import MrPlay from './pages/reviews/MrPlay';
import Slots from './pages/Slots';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsConditions from './pages/TermsConditions';
import CookiePolicy from './pages/CookiePolicy';
import ResponsibleGaming from './pages/ResponsibleGaming';
import AgeVerification from './components/AgeVerification';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AgeVerification />
      <CookieConsent />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/getting-started" element={<GettingStarted />} />
        <Route path="/guides/casino-bonuses" element={<CasinoBonuses />} />
        <Route path="/guides/choosing-safe-casino" element={<ChoosingSafeCasino />} />
        <Route path="/guides/payment-methods" element={<PaymentMethods />} />
        <Route path="/guides/slot-games-strategy" element={<SlotGamesStrategy />} />
        <Route path="/guides/table-games-guide" element={<TableGamesGuide />} />
        <Route path="/guides/live-casino-games" element={<LiveCasinoGames />} />
        <Route path="/guides/responsible-gambling" element={<ResponsibleGambling />} />
        <Route path="/guides/withdrawing-winnings" element={<WithdrawingWinnings />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/new-uk-gambling-regulations-2026" element={<NewUKGamblingRegulations2026 />} />
        <Route path="/news/top-5-casino-bonuses-december-2025" element={<Top5CasinoBonusesDecember2025 />} />
        <Route path="/news/how-to-spot-trustworthy-online-casino" element={<HowToSpotTrustworthyOnlineCasino />} />
        <Route path="/news/uk-casino-industry-record-growth-2025" element={<UKCasinoIndustryRecordGrowth2025 />} />
        <Route path="/news/payment-methods-revolutionizing-uk-casino-withdrawals" element={<PaymentMethodsRevolutionizingUKCasinoWithdrawals />} />
        <Route path="/news/live-casino-games-future-online-gaming" element={<LiveCasinoGamesFutureOnlineGaming />} />
        <Route path="/news/cryptocurrency-adoption-uk-online-casinos" element={<CryptocurrencyAdoptionUKOnlineCasinos />} />
        <Route path="/news/slot-game-innovations-whats-new-2025" element={<SlotGameInnovations2025 />} />
        <Route path="/news/responsible-gambling-new-tools-uk-players" element={<ResponsibleGamblingNewToolsUKPlayers />} />
        <Route path="/news/:slug" element={<NewsArticle />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/reviews/pub-casino" element={<PubCasino />} />
        <Route path="/reviews/nrg" element={<NRG />} />
        <Route path="/reviews/mr-play" element={<MrPlay />} />
        <Route path="/slots" element={<Slots />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/responsible-gaming" element={<ResponsibleGaming />} />
        <Route path="/contact" element={<ContactPage />} />
      </Routes>
    </Router>
  );
}

export default App;
